import React from 'react';
import {
    Typography,
    Box,
} from "@mui/material";

export const BranchColumns = () => [
    {
        id: "name",
        label: "Name",
        render: (value, row) => {
            const name = row.name_en || row.name_hy || row.name_ru || 'No name';
            return (
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {name}
                </Typography>
            );
        }
    },
    {
        id: "phone",
        label: "Phone",
        render: (value) => (
            <Typography sx={{ color: "text.secondary" }}>
                {value}
            </Typography>
        )
    },
    {
        id: "sort_order",
        label: "Order",
        render: (value) => (
            <Typography sx={{ textAlign: 'center' }}>
                {value ?? 0}
            </Typography>
        )
    },
    {
        id: "media",
        label: "Media",
        render: (value, row) => {
            const count = Array.isArray(row.media) ? row.media.length : 0;
            return (
                <Typography sx={{ textAlign: 'center' }}>
                    {count}
                </Typography>
            );
        }
    },
];
